var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7509 10.1941C18.7509 9.47471 18.6913 8.94971 18.5624 8.40527H10.1794V11.6525H15.1C15.0009 12.4594 14.4652 13.6747 13.2747 14.4913L13.258 14.6L15.9085 16.6123L16.0921 16.6303C17.7786 15.1039 18.7509 12.858 18.7509 10.1941Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1789 18.75C12.5896 18.75 14.6134 17.9722 16.0916 16.6305L13.2741 14.4916C12.5202 15.0068 11.5082 15.3666 10.1789 15.3666C7.81782 15.3666 5.81388 13.8402 5.09953 11.7305L4.99482 11.7392L2.23877 13.8295L2.20273 13.9277C3.67096 16.786 6.68683 18.75 10.1789 18.75Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.09977 11.7302C4.91129 11.1858 4.8022 10.6024 4.8022 9.99967C4.8022 9.39686 4.91129 8.81355 5.08986 8.26911L5.08486 8.15316L2.29427 6.0293L2.20297 6.07186C1.59784 7.25798 1.25061 8.58995 1.25061 9.99967C1.25061 11.4094 1.59784 12.7413 2.20297 13.9274L5.09977 11.7302Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.179 4.63331C11.8555 4.63331 12.9864 5.34303 13.6313 5.93612L16.1512 3.525C14.6036 2.11528 12.5896 1.25 10.179 1.25C6.68685 1.25 3.67097 3.21387 2.20273 6.07218L5.08963 8.26943C5.8139 6.15972 7.81785 4.63331 10.179 4.63331Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.7054dd7ecabe675a04a4430ae611a041.svg";
export { ForwardRef as ReactComponent };